import * as React from 'react'

import { PublicClassNames } from 'embed/constants'
import { MortgageOffer } from 'embed/constants/models'
import { MortgageLoanTypeNames } from 'even-ts-static'

const styles = require('./styles.scss')

export interface Props {
  mortgageOffer: MortgageOffer
  onMortgageOfferClick: (MortgageOffer) => void
}

const PERCENT = '%'
const CURRENCY = '$'

export const formatInterest = (interest: number) => (Math.round(interest * 1000) / 1000).toString().padEnd(5, '0')

const MortgageOfferListItem: React.SFC<Props> = (props) => {
  const partnerLogo =
    props.onMortgageOfferClick !== undefined ? (
      <a className={styles.partnerLogoLink} onClick={props.onMortgageOfferClick}>
        <img src={`${props.mortgageOffer?.partner?.imageUrl}`} width="120" />
      </a>
    ) : (
      <img src={`${props.mortgageOffer?.partner?.imageUrl}`} width="120" />
    )

  return (
    <li className={PublicClassNames.Offer}>
      {partnerLogo}
      <div>{MortgageLoanTypeNames[props.mortgageOffer?.details?.loanType]}</div>
      <div>
        Interest rate: {formatInterest(props.mortgageOffer?.details?.interestRate)}
        {PERCENT}
      </div>
      <div>
        APR: {formatInterest(props.mortgageOffer?.details?.apr)}
        {PERCENT}
      </div>
      <div>
        Payment / Mo: {CURRENCY}
        {props.mortgageOffer?.details?.monthlyPayment}
      </div>
      <div>
        Points / Credits: {CURRENCY}
        {props.mortgageOffer?.details?.priceAdjustment}
      </div>
      <div>
        Net Closing Costs: {CURRENCY}
        {props.mortgageOffer?.details?.netClosingCosts}
      </div>
      <button onClick={props.onMortgageOfferClick}>Continue</button>
    </li>
  )
}

export default MortgageOfferListItem
